import React from "react";
import "./VenmoOpenFailedModal.css";
import { useTranslation } from "react-i18next";
import "../containers/ModalTheme.css";

export default function VenmoOpenFailedModal(props) {
  const { t } = useTranslation();
  const { modalId, onCopyLink, copied = false } = props;

  const title = t("general.open_venmo_failed_title", { defaultValue: "Open Venmo failed?" });
  const subtitle = t("general.open_venmo_failed_subtitle", {
    defaultValue: "Some in-app browsers (e.g. WeChat) can block opening the Venmo app.",
  });

  const instruction = t("general.open_venmo_failed_instruction", {
    defaultValue:
      "Open this AnimalSplit page in your default browser (Safari/Chrome), then tap “Pay with Venmo” again.",
  });

  const useDefaultBrowserLabel = t("general.use_default_browser", {
    defaultValue: "Use default browser to open",
  });

  const copyLinkLabel = t("general.copy_link", { defaultValue: "Copy link" });
  const copiedLabel = t("general.copied", { defaultValue: "Copied" });
  const closeLabel = t("general.close", { defaultValue: "Close" });

  // Mock tiles (inspired by WeChat / iOS share sheet). We keep this lightweight and informative.
  const tiles = [
    { icon: "⭐", label: t("general.favorite", { defaultValue: "Favorite" }) },
    { icon: "📦", label: t("general.save", { defaultValue: "Save" }) },
    { icon: "⚠️", label: t("general.report", { defaultValue: "Report" }) },
    { icon: "🔗", label: t("general.copy_link", { defaultValue: "Copy link" }) },
    { icon: "🔄", label: t("general.refresh", { defaultValue: "Refresh" }) },
  ];

  return (
    <div className="modal fade as-venmo-fallback-modal" id={modalId} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content as-modal as-theme">
          <div className="modal-header">
            <div className="as-modal-header-row">
              <div className="as-modal-title-row">
                <span className="as-modal-icon-badge" aria-hidden="true">
                  🧭
                </span>
                <div style={{ minWidth: 0 }}>
                  <h5 className="modal-title text-truncate" style={{ maxWidth: "100%" }}>
                    {title}
                  </h5>
                  <div className="as-venmo-fallback-subtitle small">{subtitle}</div>
                </div>
              </div>
              <div className="as-modal-actions">
                <button type="button" className="btn-close" data-bs-dismiss="modal" />
              </div>
            </div>
          </div>

          <div className="modal-body">
            <div className="small">{instruction}</div>

            <div className="as-venmo-fallback-mock as-card shadow-sm as-theme" aria-hidden="true">
              <div className="as-venmo-fallback-grid">
                {tiles.slice(0, 4).map((t0) => (
                  <div key={t0.label} className="as-venmo-fallback-tile">
                    <div className="as-venmo-fallback-icon">{t0.icon}</div>
                    <div className="as-venmo-fallback-label">{t0.label}</div>
                  </div>
                ))}
                <div className="as-venmo-fallback-tile as-highlight">
                  <div className="as-venmo-fallback-icon">🌐</div>
                  <div className="as-venmo-fallback-label">{useDefaultBrowserLabel}</div>
                </div>
                <div className="as-venmo-fallback-tile">
                  <div className="as-venmo-fallback-icon">🔄</div>
                  <div className="as-venmo-fallback-label">
                    {t("general.refresh", { defaultValue: "Refresh" })}
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="modal-footer as-modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              {closeLabel}
            </button>
            {typeof onCopyLink === "function" ? (
              <button type="button" className="btn btn-primary as-btn-primary-gradient" onClick={onCopyLink}>
                {copied ? copiedLabel : copyLinkLabel}
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

